import ShopifyUtil from 'utils/shopify-util';

export const getProductData = async (productId, variantId = null) => {
  if (productId) {
    try {
      const productData = await ShopifyUtil.getProductData(productId);
      const variant = variantId || productData.product.variants.edges[0]?.node.id;
      const fetchedVariant = ShopifyUtil.processLineProductData(productData, variant);

      return {
        variant: fetchedVariant,
        productTags: productData.product.tags || [],
      };
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }
  return null;
};

export const getProductPrice = (variant, productTags) => {
  let discountPercent = 0;
  const { currencyCode } = variant.price;

  if (window.TMW.pricingPromos) {
    const promotions = window.TMW.pricingPromos;
    const filteredPromotions = promotions.filter((promotion) => productTags?.includes(promotion.product_tag));

    if (filteredPromotions.length > 0) {
      const pricingPromo = filteredPromotions.reduce((max, promotion) =>
        promotion.discount_percentage > max.discount_percentage ? promotion : max,
      );
      discountPercent = Number(pricingPromo.discount_percentage);
    }
  }

  const initialPrice = variant.price.amount;
  const initialCompareAtPrice = variant.compareAtPrice?.amount || null;

  if (discountPercent > 0) {
    const discountAmount = (discountPercent / 100) * initialPrice;
    const toFixed = (n, fixed) => `${n}`.match(new RegExp(`^-?\\d+(?:\\.\\d{0,${fixed}})?`))[0];
    const roundedDiscountAmount = toFixed(discountAmount, 2);

    const variantPrice = initialPrice - roundedDiscountAmount;
    let compareAtPrice = initialCompareAtPrice || initialPrice;
    if (initialCompareAtPrice < variantPrice) {
      compareAtPrice = initialPrice;
    }
    return {
      price: {
        amount: Number(variantPrice),
        currencyCode,
      },
      compareAtPrice: {
        amount: Number(compareAtPrice),
        currencyCode,
      },
    };
  }

  const compareAtPrice = initialCompareAtPrice || 0;
  return {
    price: { amount: Number(initialPrice), currencyCode },
    compareAtPrice: { amount: Number(compareAtPrice), currencyCode },
  };
};
